import {
  type AppointmentEventType,
  EventTypeName,
  type Field,
} from '@pbt/pbt-ui-components'

import EnumSelect, {
  type EnumSelectProps,
} from '~/components/common/inputs/EnumSelect'
import { AppointmentStateColorMap } from '~/constants/event'
import { useFilteredAppointmentStatuses } from '~/utils/appointmentStatusUtils'
import { useEventType } from '~/utils/useEventType'

export interface AppointmentStatusSelectProps extends Omit<
  EnumSelectProps,
  'field' | 'accent' | 'Constant'
> {
  field: Field
}

const AppointmentStatusSelect = ({
  field,
  ...rest
}: AppointmentStatusSelectProps) => {
  const AppointmentStatuses: AppointmentEventType['states'] = useEventType(
    EventTypeName.Appointment,
    'states',
  )

  const filteredStatuses = useFilteredAppointmentStatuses(AppointmentStatuses)

  return (
    <EnumSelect
      accent
      Constant={AppointmentStatuses}
      colorVariantMap={AppointmentStateColorMap}
      field={field}
      filter={(entry) => {
        // Always include the currently selected value
        if (entry.id === field.value) {
          return true
        }
        return filteredStatuses.some((status) => status.id === entry.id)
      }}
      {...rest}
    />
  )
}

export default AppointmentStatusSelect
